import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { AppMenuSection } from "../../../../../../../../common/routesUtils";
import { useBreadcrumbs } from "../../../../../../../../context/BreadcrumbsProvider";
import SectionItem from "../SectionItem";

interface Props {
	menuIsOpen: boolean;
	item: AppMenuSection;
}

/**
 * SingleRoute renders a single item of the application side menu which
 * contains only 1 route.
 *
 * @param menuIsOpen this flag is used to correctly render the menu item
 * @param item       section and routes managed by the item
 * @returns          an item of the application side menu
 */
const SingleRoute: FC<Props> = ({ menuIsOpen, item }) => {
	const navigateTo = useNavigate();
	const { breadcrumbs, visitPage } = useBreadcrumbs();

	// Determine if this menu item is selected based on the last breadcrumb
	const isSelected = breadcrumbs.length > 0 && breadcrumbs[breadcrumbs.length - 1].pageType === item.pageType;

	const itemClicked = () => {
		if (item.route) {
			visitPage(item.pageType, true); // mark breadcrumb and reset
			navigateTo(item.route); // navigate to route
		}
	};

	return <SectionItem itemKey={item.key} isSelected={isSelected} menuIsOpen={menuIsOpen} onClick={itemClicked} />;
};

export default SingleRoute;
